import { AxiosResponse, AxiosError } from "axios";
import { prepareError } from "../../../utils/error";
import api from "../../../data/api";
import { OptionCl } from "../../../components/select-cl";
import { Dispatch } from "redux";


export const DEPO_CODE_DOMAIN = "DCODE"

export type DepoCode = {
    code: string
    name:string
}

const prepareDepoCodes  = ( response : DepoCode[]   ) => {
    const opts: OptionCl[] = response.map( (dcode : DepoCode) => ({
        id : dcode.code,
        description: dcode.code + '-' + dcode.name
    })
    )
    return opts;
}


// depository codes for the depository dropdown
export const fetchDepoCodes = (
    dispatch : Dispatch<any>,
    componentType: "DepositoryCriteria"
) => {
    api
        .post("/codelist/v1/Depository/depcodes")
        .then( (response:AxiosResponse) => {
            if (response.data && response.data.result === "ERROR") {
                dispatch({ type: componentType + "/FETCHERROR", payload: prepareError(response.data) })
            } else { 
                const depoCodes : DepoCode[] = response.data.Depository; 
                dispatch({type: componentType + "/DOMAINLOADED", payload: prepareDepoCodes(depoCodes), domain: DEPO_CODE_DOMAIN })
            }
        }).catch( (error:AxiosError) => {
            if (error.request) {
                console.log(error.request);
            } 
            if (error.response) {
                console.log(error.response);
            } 
            
            dispatch({ type: componentType + "/FETCHERROR", payload: prepareError(error) })
        })

}
